import React, { Fragment, useState } from "react";
import { Form } from "react-bootstrap";
import { useParams } from "react-router-dom";
import axios from "axios";
import swal from "sweetalert";

const Checkout = () => {
  const [amounta, setAmount] = useState(1);
  const [depositInput, setDepositInput] = useState({
    amount: amounta,
    password: '',
    error_list: [],
  });
  const [loading, setLoading] = useState(false);

  const handleIncrement = () => {
    setAmount(prev => prev + 1);
    setDepositInput(prev => ({
      ...prev,
      amount: prev.amount + 1,
    }));
  };

  const handleDicrement = () => {
    setAmount(prev => Math.max(prev - 1, 1));
    setDepositInput(prev => ({
      ...prev,
      amount: Math.max(prev.amount - 1, 1),
    }));
  };

  const handleInput = (e) => {
    setDepositInput({ ...depositInput, [e.target.name]: e.target.value });
  };

  const depositSubmit = (e) => {
    e.preventDefault();
    const auth_token = localStorage.getItem('auth_token');
    const data = {
      amount: amounta,
      password: depositInput.password,
      key_s: 'eyJ0eXAiOiJKV1Qidfg%!#%$%LCdf#*&*JhbGciOiJSUzI1NiJ9'
    };

    if (auth_token && !loading) {
      setLoading(true);
      axios.post(`/sub-node`, data).then(res => {
        if (res.data.status === 'success') {
          swal("Success", res.data.message, "success");
          setDepositInput({ amount: '', password: '', error_list: [] });
        } else if (res.data.status === 'fail') {
          swal("Warning", res.data.message, "warning");
        } else {
          setDepositInput(prev => ({ ...prev, error_list: res.data.validation_error }));
        }
        setLoading(false);
      });
    }
  };

  return (
    <Fragment>
      <div className="row justify-content-center  mt-3">
        <div className="col-xl-10">
          <div 
            className="card shadow-lg rounded-4 border-0"
            style={{
              background: 'linear-gradient(135deg, #1f4037 0%, #99f2c8 100%)',
              color: '#fff'
            }}
          >
            <div className="card-body p-5">
              <div className="row">
                {/* Left side - Node Summary */}
                <div className="col-md-5 mb-4">
                  <h4 className="text-uppercase fw-bold mb-4 text-white">Node Summary</h4>
                  <ul className="list-group list-group-flush">
                    <li className="list-group-item bg-transparent d-flex justify-content-between align-items-center text-white">
                      <div>
                        <h6 className="mb-1 text-white">Node Security</h6>
                        <small>Safe and Secure Node</small>
                      </div>
                      <span className="badge bg-success rounded-pill">100%</span>
                    </li>
                    <li className="list-group-item bg-transparent d-flex justify-content-between align-items-center text-white">
                      <div>
                        <h6 className="mb-1 text-white">Total Node</h6>
                        <small>Current Count</small>
                      </div>
                      <span className="fw-bold">{amounta}</span>
                    </li>
                    <li className="list-group-item bg-transparent d-flex justify-content-between align-items-center text-white">
                      <div>
                        <h6 className="mb-1 text-white">Total Amount</h6>
                        <small>Purchase Cost</small>
                      </div>
                      <span className="fw-bold">${depositInput.amount * 200}</span>
                    </li>
                  </ul>
                </div>

                {/* Right side - Form */}
                <div className="col-md-7">
                  <h4 className="text-uppercase fw-bold mb-4 text-white">Add New Node</h4>
                  <form onSubmit={depositSubmit} noValidate>
                    <div className="mb-3">
                      <label className="form-label">Node Count</label>
                      <div className="input-group">
                        <button type="button" className="btn btn-light" onClick={handleDicrement}>
                          <i className="fa fa-minus"></i>
                        </button>
                        <input
                          type="text"
                          className="form-control text-center bg-light"
                          value={amounta}
                          readOnly
                        />
                        <button type="button" className="btn btn-light" onClick={handleIncrement}>
                          <i className="fa fa-plus"></i>
                        </button>
                      </div>
                      <small className="text-danger">{depositInput.error_list.amount}</small>
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Account Password</label>
                      <input
                        type="password"
                        className="form-control bg-light"
                        placeholder="Enter Password"
                        name="password"
                        value={depositInput.password}
                        onChange={handleInput}
                        required
                      />
                      <small className="text-danger">{depositInput.error_list.password}</small>
                    </div>

                    <div className="form-check mb-4">
                      <input type="checkbox" className="form-check-input" id="terms" required />
                      <label className="form-check-label" htmlFor="terms">
                        I accept Terms & Conditions
                      </label>
                    </div>

                    <button type="submit" className="btn btn-warning w-100 py-2 fw-bold" disabled={loading}>
                      {loading ? 'Processing...' : 'Add Node'}
                    </button>
                  </form>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Checkout;
